import config from "@/config";
var mutations = {
    /**
     * 準備完了
     */
    setup: function (state) {
        state.ready = true;
    },
    /**
     * ステージ情報を更新
     * @param payload
     */
    setStageInfo: function (state, payload) {
        var windowWidth = payload.windowWidth, windowHeight = payload.windowHeight, stageWidth = payload.stageWidth, stageHeight = payload.stageHeight, stageScrollWidth = payload.stageScrollWidth, stageScrollHeight = payload.stageScrollHeight;
        state.stage = {
            width: stageWidth,
            height: stageHeight,
            scrollWidth: stageScrollWidth,
            scrollHeight: stageScrollHeight,
            isLarge: config.breakPointL <= windowWidth,
            isMedium: config.breakPointS < windowWidth && windowWidth < config.breakPointL,
            isSmall: windowWidth <= config.breakPointS,
            isPortrait: windowWidth < windowHeight,
            isLandscape: windowHeight < windowWidth,
            isSquare: windowWidth === windowHeight,
        };
    },
    /**
     * スクロール情報を更新
     * @param payload
     */
    setScrollInfo: function (state, payload) {
        var scrollY = payload.scrollY, lastScrollY = payload.lastScrollY, scrollHeight = payload.scrollHeight;
        var height = state.stage.height;
        var bottom = Math.floor(scrollY + height);
        if (scrollY !== lastScrollY) {
            var vel = scrollY - lastScrollY;
            state.scrollY = {
                bottom: bottom,
                isDown: 0 < vel,
                middle: scrollY + Math.floor(height * 0.5),
                top: Math.floor(scrollY),
                vel: vel,
            };
        }
        state.isBottomPage = scrollHeight - 1 <= bottom;
    },
    /**
     * スクロール開始
     * @param state
     */
    beginScroll: function (state) {
        state.scrollActive = true;
    },
    /**
     * スクロール終了
     * @param state
     */
    endScroll: function (state) {
        state.scrollActive = false;
    },
    /**
     * ヘッダーの高さを設定
     * @param state
     * @param payload
     */
    setHeaderHeight: function (state, _a) {
        var height = _a.height;
        state.headerHeight = height;
    },
    /**
     * フッターの高さを設定
     * @param state
     * @param payload
     */
    setFooterHeight: function (state, _a) {
        var height = _a.height;
        state.footerHeight = height;
    },
    /**
     * メニューを開く
     * @param state
     */
    openMenu: function (state) {
        state.isMenuOpen = true;
    },
    /**
     * メニューを閉じる
     * @param state
     */
    closeMenu: function (state) {
        state.isMenuOpen = false;
    },
    /**
     * メニューの開閉
     * @param state
     */
    toggleMenu: function (state) {
        state.isMenuOpen = !state.isMenuOpen;
    },
    /**
     * メニューオープン開始
     * @param state
     */
    beginOpenMenu: function (state) {
        state.menuOpenProgress = true;
    },
    /**
     * メニューオープン終了
     * @param state
     */
    endOpenMenu: function (state) {
        state.menuOpenProgress = false;
    },
    /**
     * メニュークローズ開始
     * @param state
     */
    beginCloseMenu: function (state) {
        state.menuCloseProgress = true;
    },
    /**
     * メニュークローズ終了
     * @param state
     */
    endCloseMenu: function (state) {
        state.menuCloseProgress = false;
    },
    /**
     * ローディング開始
     * @param state
     */
    beginLoad: function (state) {
        state.loadProgress = true;
    },
    /**
     * ローディング終了
     * @param state
     */
    endLoad: function (state) {
        state.loadProgress = false;
    },
    /**
     * モーダルオープン開始
     * @param state
     */
    beginOpenModal: function (state) {
        state.modalOpenProgress = true;
        state.isModalOpen = true;
    },
    /**
     * モーダルオープン終了
     * @param state
     */
    endOpenModal: function (state) {
        state.modalOpenProgress = false;
    },
    /**
     * モーダルクローズ開始
     * @param state
     */
    beginCloseModal: function (state) {
        state.modalCloseProgress = true;
    },
    /**
     * モーダルクローズ終了
     * @param state
     */
    endCloseModal: function (state) {
        state.modalCloseProgress = false;
        state.isModalOpen = false;
    },
    /**
     * 遷移開始
     * @param state
     */
    startTransition: function (state) {
        state.transitionProgress = true;
    },
    /**
     * 遷移完了
     * @param state
     */
    completeTransition: function (state) {
        state.transitionProgress = false;
    },
    /**
     * 遷移時のEnter開始
     * @param state
     */
    startEnter: function (state) {
        state.enterProgress = true;
    },
    /**
     * 遷移時のEnter完了
     * @param state
     */
    completeEnter: function (state) {
        state.enterProgress = false;
    },
    /**
     * 遷移時のLeave開始
     * @param state
     */
    startLeave: function (state) {
        state.leaveProgress = true;
    },
    /**
     * 遷移時のLeave完了
     * @param state
     */
    completeLeave: function (state) {
        state.leaveProgress = false;
    },
    /**
     * ページ名を設定
     * @param state
     * @param payload
     */
    setPageName: function (state, payload) {
        state.pageName = payload.pageName;
    },
    enterTopExperienceItem: function (state) {
        state.isHoverAtTopExperienceItem = true;
    },
    leaveTopExperienceItem: function (state) {
        state.isHoverAtTopExperienceItem = false;
    },
};
export default mutations;
